import {AfterViewInit, Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DeviceDetectorService} from "ngx-device-detector";
import {ChannelsState} from "@portals/store";
import {Channel, LINK_DOMAINS, LINK_RESPONSE, LINK_TYPES, LinkService, Notification} from "@portals/api";
import {environment} from "@portals/environments";
import {catchError, of, tap} from "rxjs";

@Component({
	selector: 'portals-redirect',
	templateUrl: './redirect.component.html',
	styleUrls: ['./redirect.component.scss'],
})
export class RedirectComponent implements AfterViewInit {
	constructor(private router: Router, private route: ActivatedRoute, private deviceService: DeviceDetectorService, private channelState: ChannelsState, private linkService: LinkService) {
	}

	ngAfterViewInit(): void {
		this.route.params.subscribe((params) => {
			this.route.queryParams.subscribe((queryParams) => {
				const url = window.location.href
				const preparedUrl = url.startsWith('http') ? url : `https://${url}`;
				const hostname = ("https://" + new URL(preparedUrl).hostname + "/") as LINK_DOMAINS;
					!queryParams['redirected'] ?
						this.linkService.getLink(hostname.replace(/www\./g, ""), params['link']).pipe(
							catchError(err => of(err)),
							tap((data: LINK_RESPONSE) => {
								switch (data.type) {
									case LINK_TYPES.CHANNEL:
										const channel = data.entity as Channel
										this.router.navigateByUrl(`subscribe/${channel.uuid}`);
										break;
									case LINK_TYPES.PROMPT:
										const prompt = data.entity as Notification
										this.router.navigateByUrl(`channels/${prompt.channel?.uuid}?id=${prompt.id}`)
										break;
									default:
										this.router.navigateByUrl(``)
										break;
								}
							})).subscribe() : this.linkService.sendToAppStore(queryParams['type'], hostname.replace(/www\./g, "") + params['link'])
				}
			)
		})
	}
}
